import { createMuiTheme } from '@material-ui/core/styles';
import { grey, lightBlue } from '@material-ui/core/colors';

export default createMuiTheme({
  overrides: {
    MuiTableCell: {
      root: {
        padding: '4px 4px 4px 0px'
      },
      head: {
        lineHeight: '1rem'
      }
    },
    MuiChip: {
      root: {
        backgroundColor: grey[100]
      }
    },
    MuiLink: {
      root: {
        color: '#0058A3'
      }
    }
  },
  palette: {
    primary: {
      main: '#0058a3'
    },
    secondary: {
      ...lightBlue,
      contrastText: '#FFFFFF'
    },
    background: {
      default: '#EEEEEF'
    },
    success: {
      main: '#0A8A00'
    },
    error: {
      main: '#E00751'
    },
    warning: {
      main: '#FFA524'
    },
    information: {
      main: '#0058A3'
    }
  }
});
